module.exports = __webpack_public_path__ + "assets/img/3.bdb6ae0d.png";